import { render, staticRenderFns } from "./cfoodhistory.vue?vue&type=template&id=067e2d74&scoped=true&"
import script from "./cfoodhistory.vue?vue&type=script&lang=js&"
export * from "./cfoodhistory.vue?vue&type=script&lang=js&"
import style0 from "./cfoodhistory.vue?vue&type=style&index=0&id=067e2d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067e2d74",
  null
  
)

export default component.exports